var styles = {"pendingAnimation":"styles_pending-animation__74S8E","circle":"styles_circle__IjOy0","innerCircle":"styles_inner-circle__a-DdJ","twinkle":"styles_twinkle__LJEfa","inheritColor":"styles_inherit-color__eoFsg"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
